import { PRIMARY_NAVIGATION, type ViewId } from './navigation';

type Props = {
  activeView: ViewId;
  onNavigate: (viewId: ViewId) => void;
};

export const MobileNav = ({ activeView, onNavigate }: Props) => {
  const mobileActiveView = PRIMARY_NAVIGATION.some(({ id }) => id === activeView) ? activeView : 'more';

  return (
    <nav className="mobile-nav" aria-label="Mobile navigation">
      {PRIMARY_NAVIGATION.map(({ id, label, icon: Icon }) => (
      <button
        type="button"
        className="mobile-nav-link"
        data-active={mobileActiveView === id}
        aria-current={mobileActiveView === id ? 'page' : undefined}
        onClick={() => onNavigate(id)}
        key={id}
      >
        <Icon size={21} aria-hidden="true" />
        <span>{label}</span>
      </button>
      ))}
    </nav>
  );
};
